import { render, staticRenderFns } from "./JsCodesConfig.vue?vue&type=template&id=0fe96304&scoped=true"
import script from "./JsCodesConfig.vue?vue&type=script&lang=js"
export * from "./JsCodesConfig.vue?vue&type=script&lang=js"
import style0 from "./JsCodesConfig.vue?vue&type=style&index=0&id=0fe96304&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe96304",
  null
  
)

export default component.exports